export default "__VITE_ASSET__CuMVKJ9E__"